import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

import 'fit-text-webcomponent';
import Helper from '../../../src/Helper.js';
import './style.scss';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';

const moduleSelector = '.eiovisual-text3';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo text3');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        
        this.timeline = new TimelineMax();
        this.controller = new ScrollMagic.Controller();

        // Tasks on images
        if(!isMobile.check()) {
            setTimeout(async () => { 
                
                new Promise(resolve => {
                    this.task1();
                });
                
                await this.task2();
            },0); // abilita effetto scrollmagic
        }
    }

    // _________________________________________________________________________

    /**
     * Sostituisce gli elementi .fit-text con elementi fit-text
     * @returns {undefined}
     */
    task1() {
        // prende il contenuto dell'elemento .fit-text
        let $target = this.$module.querySelector('.fit-text');
        Dom.wrapInner($target,'fit-text');
    }

    // _________________________________________________________________________

    /**
     * Abilità ingresso con scroll della scritta fit-text
     */
    task2() {
        // Target
        let $target = this.$module.querySelector('.fit-text');

        var tweenCaption = this.timeline
            .to($target, 2, {opacity: 1, transform: "translateX(-10%) translateY(0)", ease: Sine.easeOut })

        new ScrollMagic.Scene({
            triggerElement: this.$module,
            triggerHook:.8, // lo pinna quando è in alto (a 0)
            duration: "70%", // e lo tiene pinnato per la duration
            offset: 50
        })
        .setTween(tweenCaption)
        // .addIndicators({name: "Pattern1.1"}) // add indicators (requires plugin)
        .addTo(this.controller);
    }

    // _________________________________________________________________________

}

// export
export default new Module();